import type { FC } from "react";

import { identity } from "lodash";

import { numberFilter } from "app/filters/ngFilters";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

const PAGE_SIZE_FALLBACK = 100;
const INDEX_COLUMN_WIDTH_PER_CHARACTER = 16;
const INDEX_COLUMN_WIDTH_PER_COMMA = 4;
const INDEX_COLUMN_MIN_WIDTH = 46;

export function getIndex(index: number, page: number, pageSize: number) {
    const indexToDisplay = page > 1 ? page * pageSize - pageSize + (index + 1) : index + 1;
    return numberFilter()(indexToDisplay);
}

export const IndexCell: FC<ITableCellProps> = ({ row, tableMetadata }) => {
    const pageSize = tableMetadata?.pageSize || PAGE_SIZE_FALLBACK;
    const isChild = row?.parent;
    const index = isChild ? "" : getIndex(row?.index, tableMetadata?.page, pageSize);

    return <div className="u-alignCenter">{index}</div>;
};
IndexCell.displayName = "IndexCell";
// we store the latest current page globally to address an issue of the closure
// created by the render method not capturing the latest value
let latestCurrentPage: number | undefined;
export const getIndexCellPropsForTableV2 = <T,>(
    currentPage: number,
    pageSize: number,
    shouldRender: (record: T) => boolean = identity,
    minWidth: number = INDEX_COLUMN_MIN_WIDTH,
) => {
    latestCurrentPage = currentPage;
    const formattedValue = getIndex(pageSize + 1, latestCurrentPage, pageSize);
    const numberOfCommas = formattedValue.split(",").length - 1;
    const numberOfCharacters = formattedValue.length - numberOfCommas;
    return {
        width: Math.max(
            numberOfCharacters * INDEX_COLUMN_WIDTH_PER_CHARACTER + numberOfCommas * INDEX_COLUMN_WIDTH_PER_COMMA,
            minWidth,
        ),
        render: (_: unknown, record: T, index: number) => {
            return shouldRender(record) ? getIndex(index, latestCurrentPage as number, pageSize) : null;
        },
        hiddenInColumnPicker: true,
        title: "",
        align: "center" as const,
        fixed: "left" as const,
        key: "index",
    };
};
